import { createAsyncThunk } from "@reduxjs/toolkit";
import { normalize } from "normalizr";
import { schema } from "normalizr";
import { updateClipListClipsEntities } from "store/clip/slice";

import coreAPI from "../../services/api/core";
import magnifiAPI from "../../services/api/magnifi";
import { clipList } from "../schemas";
import { updateClipListEntity } from "./slice";

export const getClipLists = createAsyncThunk("clipList/getClipLists", async (payload) => {
  try {
    const response = await magnifiAPI.getClipLists(payload);

    return {
      ...response.data,
      ...(response.data.status ? normalize(response.data.data, [clipList]) : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateClipList = createAsyncThunk(
  "clipList/updateClipList",
  async ({ clipListId, payload }, { dispatch }) => {
    try {
      let response = await magnifiAPI.updateClipList({ clipListId, payload });

      const clipListData = response?.data?.data;

      if (clipListData) {
        dispatch(updateClipListEntity(clipListData));
        dispatch(updateClipListClipsEntities(clipListData));
      }

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getStreamClipLists = createAsyncThunk("clipList/getStreamClipLists", async ({ payload, params }) => {
  try {
    const response = await magnifiAPI.getStreamClipLists({ payload, params });

    return {
      ...response.data,
      ...(response.data.success ? normalize(response.data.data, [clipList]) : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const deleteClipList = createAsyncThunk("clipList/deleteClipList", async (payload) => {
  try {
    const response = await magnifiAPI.deleteClipList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const exportClipListJSON = createAsyncThunk("clipList/exportClipListJSON", async (payload) => {
  try {
    const response = await magnifiAPI.exportClipListJSON(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAdvancedEditorDetails = createAsyncThunk("clipList/getAdvancedEditorDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getAdvancedEditorDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createClipListFolder = createAsyncThunk("clipList/createFolder", async (payload) => {
  try {
    const response = await magnifiAPI.createClipListFolder(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateClipListFolder = createAsyncThunk("clipList/updateFolder", async (payload) => {
  try {
    const response = await magnifiAPI.updateClipListFolder(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getClipListDetails = createAsyncThunk("clipList/getClipListDetails", async (payload) => {
  try {
    const response = await magnifiAPI.getClipListDetails(payload);

    return {
      ...response.data,
      ...(response.data.success ? normalize(response.data.data, [clipList]) : {}),
    };
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getInfinitePaginatedClipLists = createAsyncThunk(
  "clipList/getInfinitePaginatedClipLists",
  async (payload) => {
    try {
      const groupByDateClipList = new schema.Entity(
        "groupByDateClipList",
        {
          data: [clipList],
        },
        {
          idAttribute: "_id",
        },
      );

      const response = await magnifiAPI.getClipLists(payload);
      const highlightsData = response.data?.data || {};
      // making data array from obj
      const formattedResp = Object.keys(highlightsData).map((key) => {
        return {
          _id: key,
          data: highlightsData[key],
        };
      });
      const normalizedData = normalize(formattedResp, [groupByDateClipList]);

      return {
        ...response.data,
        ...(response.data.status ? normalizedData : {}),
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
export const generateHighlightPreview = createAsyncThunk("clipList/generateHighlightPreview", async (payload) => {
  try {
    const response = await magnifiAPI.generateHighlightPreview(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const generateSocialMediaCaptionForHighlight = createAsyncThunk(
  "clipList/generateSocialMediaCaptionForHighlight",
  async (payload) => {
    try {
      const response = await magnifiAPI.generateSocialMediaCaptionForHighlight(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const listClipListSelectionVariants = createAsyncThunk(
  "clipList/listClipListSelectionVariants",
  async (payload) => {
    try {
      const response = await coreAPI.listClipListReferenceVariants(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const createClipListSelectionVariant = createAsyncThunk(
  "clipList/createClipListSelectionVariant",
  async (payload) => {
    try {
      const response = await coreAPI.createClipListReferenceVariant(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const deleteClipListSelectionVariant = createAsyncThunk(
  "clipList/deleteClipListSelectionVariant",
  async (payload) => {
    try {
      const response = await coreAPI.deleteClipListReferenceVariant(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
